import TiptapBold from '@tiptap/extension-bold';

export const Bold = TiptapBold.extend({ name: 'strong' });
